import { FilterStatus } from '../../../../common/enums/FilterStatus';
import { RemediationTag } from '../../../../common/enums/RemediationTag';
import { Severity } from '../../../../common/enums/Severity';
import { Remediation } from '../../../../common/models/Remediation';
import { ReportPrintData } from '../../report/models/ReportPrintData';
import { Issue } from './valueObjects/Issue';

export class InstancePrintData {
  constructor(
    private readonly number: number,
    private readonly numberLocal: number | null,
    private readonly severity: Severity,
    private readonly data: string,
    private readonly filterStatus: FilterStatus,
    private readonly remediation: Remediation | null,
    private readonly remediationTag: RemediationTag | null,
    private readonly issue: Issue | null,
    private readonly report: ReportPrintData,
    private readonly callsCount: number,
    private readonly operationsCount: number,
    private readonly locationsCount: number
  ) {}

  getNumber() {
    return this.number;
  }

  getNumberLocal() {
    return this.numberLocal;
  }

  getSeverity() {
    return this.severity;
  }

  getData() {
    return this.data;
  }

  getFilterStatus() {
    return this.filterStatus;
  }

  getRemediation() {
    return this.remediation;
  }

  getSpecificRemediationTag() {
    return this.remediationTag;
  }

  getReport() {
    return this.report;
  }

  getIssue() {
    return this.issue;
  }

  getCallsCount() {
    return this.callsCount;
  }

  getOperationsCount() {
    return this.operationsCount;
  }

  getLocationsCount() {
    return this.locationsCount;
  }
}
